var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"id":"user-nav"}},[_c('ul',{staticClass:"nav nav-pills"},[_c('li',[_c('router-link',{attrs:{"to":{
        name: 'users'
      }}},[_vm._v("\n        Users\n      ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{
        name: 'create_user'
      }}},[_vm._v("\n        New User\n      ")])],1),_vm._v(" "),(_vm.userId && this.$root.isAdmin)?_c('li',[_c('router-link',{attrs:{"to":{
        name: 'edit_user',
        params: { userId: _vm.userId }
        }}},[_vm._v("\n        Edit User\n      ")])],1):_vm._e(),_vm._v(" "),(_vm.userId && this.$root.isAdmin)?_c('li',[_c('router-link',{attrs:{"to":{
        name: 'edit_user_details',
        params: { userId: _vm.userId }
        }}},[_vm._v("\n        Edit User Profile\n      ")])],1):_vm._e(),_vm._v(" "),(this.$root.isAdmin)?_c('li',[_c('router-link',{attrs:{"to":{
        name: 'debug_auth',
        params: { userId: _vm.userId }
        }}},[_vm._v("\n        Debug User Auth\n      ")])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2044f0f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserNav.vue
// module id = 1146
// module chunks = 1